import React, { Component } from 'react'
import styles from './conflict-resolution.styles'
import injectSheet from 'react-jss'
import Wizard from './wizard/wizard.container'
import Spinner from 'pobble-components/dist/spinner'

class ConflictResolution extends Component {
  componentDidMount() {
    const { schoolId, onMount } = this.props
    onMount(schoolId)
  }
  render() {
    const { classes, pending } = this.props
    return (
      <div className={classes.container}>
        {!pending && <Wizard />}
        {pending && <Spinner className={classes.spinner} />}
      </div>
    )
  }
}

export default injectSheet(styles)(ConflictResolution)
